function SetAsSecondDirective() {
	return {
		restrict: 'A',
		require: 'ngModel',
		controllerAs: 'vm',
		link: function(scope, el, attr, ctrl) {

			ctrl.$formatters.push(function(modelValue) {
				return Math.round(modelValue / 1000);
			});

			ctrl.$parsers.push(function(viewValue) {
				return viewValue * 1000;
			});
		}
	}
}

module.exports = SetAsSecondDirective;


// WEBPACK FOOTER //
// ./resources/WEB-INF/package/system/dashboard/SetAsSecondDirective.js